import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';
import parseIcons from '../parseIcons.js';
import * as faInfoCircle from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import * as faExclamationTriangle from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import * as faCheckCircle from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import * as faExclamationCircle from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import * as faQuestionCircle from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import * as faTimes from '@fortawesome/free-solid-svg-icons/faTimes';
import * as faSearch from '@fortawesome/free-solid-svg-icons/faSearch';

var parseOverrideIcons = function parseOverrideIcons(icons) {
  return icons.reduce(function (currentIcons, iconSet) {
    return _objectSpread({}, currentIcons, parseIcons(iconSet.icons, {
      type: iconSet.type,
      prefix: iconSet.prefix
    }));
  }, {});
};

var Icon = function Icon(overrides) {
  return _objectSpread({}, _get(overrides, 'Icon', {}), {
    icons: _objectSpread({}, parseIcons([faInfoCircle, faExclamationTriangle, faCheckCircle, faExclamationCircle, faQuestionCircle, faTimes, faSearch], {
      type: 'font-awesome-standalone'
    }), parseOverrideIcons(_get(overrides, 'Icon.iconSets', [])), _get(overrides, 'Icon.icons', {})),
    iconNames: _objectSpread({
      info: 'info-circle',
      warning: 'exclamation-triangle',
      success: 'check-circle',
      danger: 'exclamation-circle'
    }, _get(overrides, 'Icon.iconNames', {}))
  });
};

export default Icon;